import { render, staticRenderFns } from "./UsageTotals.vue?vue&type=template&id=0ea70906"
import script from "./UsageTotals.vue?vue&type=script&lang=js"
export * from "./UsageTotals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports